import(/* webpackMode: "eager", webpackExports: ["StandaloneClientProviders"] */ "/tmp/seed/source/apps/web/app/(webphone-standalone)/StandaloneClientProviders.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/seed/source/apps/web/styles/webphone-standalone.css");
;
import(/* webpackMode: "eager" */ "/tmp/seed/source/apps/web/styles/normalGlobals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/seed/source/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/tmp/seed/source/node_modules/next/font/google/target.css?{\"path\":\"lib/fonts.ts\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-sans\"}],\"variableName\":\"fontSans\"}");
;
import(/* webpackMode: "eager" */ "/tmp/seed/source/node_modules/next/font/google/target.css?{\"path\":\"lib/fonts.ts\",\"import\":\"JetBrains_Mono\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-mono\"}],\"variableName\":\"fontMono\"}");
